import { ReactNode } from 'react'

interface IconButtonProps {
  children: ReactNode
  onClick?: () => void
  ariaLabel: string
  className?: string
  disabled?: boolean
}

export default function IconButton({
  children,
  onClick,
  ariaLabel,
  className = '',
  disabled = false,
}: IconButtonProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={`btn-icon ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
    >
      {children}
    </button>
  )
}
